<template>
  <div>
    <h1>{{ get("header-1") }}</h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="5" xl="5" lg="5" md="5" sm="5">
            <p>
              {{ get("p-1.1") }} 
              <linkto :text="company" to="/"></linkto>
              {{ get("p-1.2") }}
              <phonenumber phone="(719) 390-7663"></phonenumber>!
            </p>
          </v-col>
          <v-col cols="7" xl="7" lg="7" md="7" sm="7">
            <v-img :src="image" class="image"></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <ul>
              <li>
                <p>
                  <strong>{{ get("p-2.1") }}</strong>
                  {{ get("p-2.2") }}
                </p>
              </li>
              <li>
                <p>
                  <strong>{{ get("p-3.1") }}</strong> 
                  {{ get("p-3.2") }}
                </p>
              </li>
              <li>
                <p>
                  <strong>{{ get("p-4.1") }}</strong> 
                  {{ get("p-4.2") }}
                </p>
              </li>
              <li>
                <p>
                  <strong>{{ get("p-5.1") }}</strong> 
                  {{ get("p-5.2") }}
                </p>
              </li>
              <li>
                <p>
                  <strong>{{ get("p-6.1") }}</strong>
                  {{ get("p-6.2") }}
                </p>
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import estimate from "@/components/controls/estimate-ctrl";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "Roofing-Materials",

  components: {
    estimate,
    phonenumber
  },

    created() {
    this.pageName = "roof-materials";
  },

  data: () => ({
    image: require("@/assets/roof-7.jpeg"),
  }),

  mixins: [localizationMixin],

  methods: {
    getLocalization() {    
    }
  },

};
</script>

<style lang="scss" scoped>

</style>
